var _defs, _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotSplashPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bot_splash_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144,
    y: 186,
    width: 24,
    height: 24,
    transform: "translate(312 396) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127 221.19 127 169 179.7 169 191.82 157 115 157 115 233.07 127 221.19"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "183 178 183 225 136 225 121 240 198 240 198 163 183 178"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotSplashPlaceholder);
export default __webpack_public_path__ + "static/media/bot_splash_placeholder.f5f126101b394ebba4b6b0e632f48af9.svg";
export { ForwardRef as ReactComponent };